export const DEFAULT_CONTENT = {
  hero_badge: { fr: "Cabinet de Conseil — Papeete, Tahiti", en: "Consulting Firm — Papeete, Tahiti" },
  hero_title: { fr: "Transformer vos projets\nen réussites durables", en: "Transforming your projects\ninto lasting successes" },
  hero_subtitle: {
    fr: "Cabinet de conseil stratégique basé à Papeete. Nous accompagnons les entreprises, les associations et les porteurs de projets de Polynésie avec une approche personnalisée, pragmatique et orientée résultats.",
    en: "Strategic consulting firm based in Papeete. We support businesses, non-profits and project founders across Polynesia with a personal, pragmatic and results-driven approach.",
  },
  marquee_items: {
    fr: "Conseil Stratégique • Accompagnement • Formation • Gestion de Projets • Organisation & Stratégie • Communication • Papeete, Tahiti",
    en: "Strategic Consulting • Support • Training • Project Management • Organization & Strategy • Communication • Papeete, Tahiti",
  },
  about_title: { fr: "Qui sommes-nous ?", en: "Who are we?" },
  about_text: {
    fr: "POLYNÉSIE GESTION ET PROJET accompagne les entreprises, les associations et les porteurs de projets dans le développement de leurs activités grâce à une approche personnalisée, pragmatique et orientée résultats.",
    en: "POLYNÉSIE GESTION ET PROJET supports businesses, non-profits and project founders in growing their activities through a personal, pragmatic and results-driven approach.",
  },
  chapter_1_title: { fr: "Ancrage Local", en: "Local Roots" },
  chapter_1_text: {
    fr: "Basés à Papeete, nous connaissons intimement le tissu économique polynésien, ses réalités, ses acteurs et ses opportunités.",
    en: "Based in Papeete, we intimately know the Polynesian economic fabric, its realities, its players and its opportunities.",
  },
  chapter_2_title: { fr: "Excellence Stratégique", en: "Strategic Excellence" },
  chapter_2_text: {
    fr: "Une approche structurée, rigoureuse et pragmatique pour chaque mission, du diagnostic à la mise en œuvre.",
    en: "A structured, rigorous and pragmatic approach to every engagement, from diagnosis to implementation.",
  },
  chapter_3_title: { fr: "Impact Durable", en: "Lasting Impact" },
  chapter_3_text: {
    fr: "Nous construisons avec vous des solutions qui perdurent bien au-delà de notre intervention.",
    en: "We build solutions with you that endure well beyond our engagement.",
  },
  service_1_title: { fr: "Conseil Stratégique", en: "Strategic Consulting" },
  service_1_desc: {
    fr: "Des analyses approfondies et des recommandations concrètes pour guider vos décisions et structurer votre développement.",
    en: "In-depth analysis and concrete recommendations to guide your decisions and structure your growth.",
  },
  service_2_title: { fr: "Accompagnement", en: "Support & Coaching" },
  service_2_desc: {
    fr: "Un accompagnement personnalisé à chaque étape de votre projet, du premier diagnostic à la mise en œuvre.",
    en: "Personalized support at every stage of your project, from first diagnosis to implementation.",
  },
  service_3_title: { fr: "Formation", en: "Professional Training" },
  service_3_desc: {
    fr: "Des programmes de formation professionnelle sur mesure pour développer durablement les compétences de vos équipes.",
    en: "Tailored professional training programs to sustainably grow your teams' skills.",
  },
  service_4_title: { fr: "Gestion de Projets", en: "Project Management" },
  service_4_desc: {
    fr: "Un pilotage rigoureux de vos projets : planification, coordination, suivi et évaluation.",
    en: "Rigorous steering of your projects: planning, coordination, monitoring and evaluation.",
  },
  service_5_title: { fr: "Organisation & Stratégie", en: "Organization & Strategy" },
  service_5_desc: {
    fr: "Optimisez vos processus et votre structure pour gagner en efficacité et en sérénité.",
    en: "Optimize your processes and structure to gain efficiency and peace of mind.",
  },
  service_6_title: { fr: "Pilotage & Prise de Décision", en: "Steering & Decision-Making" },
  service_6_desc: {
    fr: "Des tableaux de bord et des indicateurs clairs pour décider vite, et décider juste.",
    en: "Clear dashboards and indicators to decide fast — and decide right.",
  },
  service_7_title: { fr: "Communication", en: "Communication" },
  service_7_desc: {
    fr: "Communication institutionnelle et stratégique pour valoriser votre image et vos actions.",
    en: "Institutional and strategic communication to showcase your image and your actions.",
  },
  step_1_title: { fr: "Écouter", en: "Listen" },
  step_1_desc: { fr: "Comprendre vos besoins, votre contexte et vos ambitions.", en: "Understanding your needs, your context and your ambitions." },
  step_2_title: { fr: "Analyser", en: "Analyze" },
  step_2_desc: { fr: "Diagnostiquer votre situation avec précision et objectivité.", en: "Diagnosing your situation with precision and objectivity." },
  step_3_title: { fr: "Construire", en: "Build" },
  step_3_desc: { fr: "Élaborer des solutions sur mesure, pragmatiques et réalistes.", en: "Designing tailored, pragmatic and realistic solutions." },
  step_4_title: { fr: "Accompagner", en: "Support" },
  step_4_desc: { fr: "Mettre en œuvre à vos côtés, pas à pas.", en: "Implementing by your side, step by step." },
  step_5_title: { fr: "Évaluer", en: "Evaluate" },
  step_5_desc: { fr: "Mesurer les résultats et ajuster pour un impact durable.", en: "Measuring results and adjusting for lasting impact." },
  client_1_title: { fr: "TPE & PME", en: "Small & Medium Businesses" },
  client_1_desc: { fr: "Structurer votre croissance et sécuriser vos décisions.", en: "Structure your growth and secure your decisions." },
  client_2_title: { fr: "Grandes Entreprises", en: "Large Companies" },
  client_2_desc: { fr: "Un regard extérieur expert sur vos projets stratégiques.", en: "An expert outside perspective on your strategic projects." },
  client_3_title: { fr: "Associations", en: "Non-Profits" },
  client_3_desc: { fr: "Professionnaliser votre organisation et vos projets.", en: "Professionalize your organization and projects." },
  client_4_title: { fr: "Collectivités", en: "Local Authorities" },
  client_4_desc: { fr: "Accompagner vos politiques publiques et vos services.", en: "Supporting your public policies and services." },
  client_5_title: { fr: "Porteurs de Projets", en: "Project Founders" },
  client_5_desc: { fr: "De l'idée au lancement, un cadre clair et rassurant.", en: "From idea to launch, a clear and reassuring framework." },
  client_6_title: { fr: "Artisans & Commerçants", en: "Artisans & Shopkeepers" },
  client_6_desc: { fr: "Développer votre activité et gagner en visibilité.", en: "Grow your business and gain visibility." },
  client_7_title: { fr: "Professions Libérales", en: "Independent Professionals" },
  client_7_desc: { fr: "Optimiser votre organisation au quotidien.", en: "Optimize your day-to-day organization." },
  client_8_title: { fr: "Organismes de Formation", en: "Training Organizations" },
  client_8_desc: { fr: "Concevoir et piloter des programmes de qualité.", en: "Design and run high-quality programs." },
  value_1_title: { fr: "Professionnalisme", en: "Professionalism" },
  value_1_desc: {
    fr: "Rigueur et excellence dans la délivrance de toutes nos prestations de conseil.",
    en: "Rigor and excellence in delivering all our consulting services.",
  },
  value_2_title: { fr: "Intégrité", en: "Integrity" },
  value_2_desc: {
    fr: "Honnêteté, transparence tarifaire et respect scrupuleux de nos engagements.",
    en: "Honesty, transparent pricing and scrupulous respect for our commitments.",
  },
  value_3_title: { fr: "Rigueur", en: "Rigor" },
  value_3_desc: {
    fr: "Précision dans les analyses, méthodologie structurée et suivi méticuleux.",
    en: "Precision in analysis, structured methodology and meticulous follow-up.",
  },
  value_4_title: { fr: "Engagement", en: "Commitment" },
  value_4_desc: {
    fr: "Investissement total à vos côtés pour l'atteinte de vos objectifs stratégiques.",
    en: "Total dedication by your side to reach your strategic goals.",
  },
  value_5_title: { fr: "Qualité de Service", en: "Service Quality" },
  value_5_desc: {
    fr: "Satisfaction client au cœur de nos priorités opérationnelles quotidiennes.",
    en: "Client satisfaction at the heart of our daily operational priorities.",
  },
  cta_title: { fr: "Parlons de votre projet", en: "Let's talk about your project" },
  cta_text: {
    fr: "Écrivez-nous en toute confidentialité : vos messages sont visibles uniquement par le cabinet. Nous vous répondrons rapidement.",
    en: "Write to us in complete confidentiality: your messages are visible only to the firm. We will reply promptly.",
  },
  contact_email: { fr: "polynesiegestionetprojet@gmail.com", en: "polynesiegestionetprojet@gmail.com" },
  contact_phone: { fr: "89 788 749", en: "+689 89 788 749" },
  contact_address: {
    fr: "Quartier du Commerce, Papeete — Tahiti, Polynésie française",
    en: "Quartier du Commerce, Papeete — Tahiti, French Polynesia",
  },
  hero_image: { fr: "", en: "" },
  about_image: { fr: "", en: "" },
  values_image: { fr: "", en: "" },
  contact_image: { fr: "", en: "" },
  video_url: { fr: "", en: "" },
  video_title: { fr: "Le cabinet en images", en: "The firm on video" },
  video_text: {
    fr: "Découvrez notre univers, notre équipe et notre approche en vidéo.",
    en: "Discover our world, our team and our approach on video.",
  },
  logo_image: { fr: "", en: "" },
  gallery_title: { fr: "Nos réalisations", en: "Our work" },
  gallery_sub: {
    fr: "Un aperçu de nos projets et de notre univers, en images.",
    en: "A glimpse of our projects and our world, in pictures.",
  },
  testimonials_title: { fr: "Ils nous font confiance", en: "They trust us" },
  testimonials_sub: {
    fr: "La parole à celles et ceux que nous accompagnons.",
    en: "Hear from those we support.",
  },
  legal_title: { fr: "Mentions légales & Confidentialité", en: "Legal Notice & Privacy" },
  mission_title: { fr: "Notre Mission", en: "Our Mission" },
  mission_text: {
    fr: "Permettre à nos clients de gagner du temps, de structurer leur organisation et de développer leurs projets avec une efficacité maximale.",
    en: "Enabling our clients to save time, structure their organization and grow their projects with maximum efficiency.",
  },
  announcement_text: { fr: "", en: "" },
  legal_text: {
    fr: "MENTIONS LÉGALES\n\nÉditeur du site : POLYNÉSIE GESTION ET PROJET — Cabinet de conseil\nAdresse : Quartier du Commerce, Papeete — Tahiti, Polynésie française\nTéléphone : 89 788 749\nE-mail : polynesiegestionetprojet@gmail.com\nDirecteur de la publication : le gérant du cabinet.\n\nHébergement : ce site est hébergé sur la plateforme Emergent.\n\nCONFIDENTIALITÉ\n\nLes informations transmises via le formulaire de contact (nom, adresse e-mail, message) sont utilisées uniquement pour répondre à votre demande. Elles sont visibles exclusivement par le cabinet et ne sont ni vendues, ni cédées, ni partagées avec des tiers.\n\nConformément à la réglementation applicable en matière de protection des données, vous disposez d'un droit d'accès, de rectification et de suppression des informations vous concernant. Pour exercer ce droit, écrivez-nous à polynesiegestionetprojet@gmail.com.\n\nPROPRIÉTÉ INTELLECTUELLE\n\nL'ensemble des contenus de ce site (textes, images, logo) est la propriété de POLYNÉSIE GESTION ET PROJET, sauf mention contraire. Toute reproduction, totale ou partielle, sans autorisation préalable est interdite.",
    en: "LEGAL NOTICE\n\nWebsite publisher: POLYNÉSIE GESTION ET PROJET — Consulting firm\nAddress: Quartier du Commerce, Papeete — Tahiti, French Polynesia\nPhone: +689 89 788 749\nEmail: polynesiegestionetprojet@gmail.com\nPublication director: the firm's manager.\n\nHosting: this website is hosted on the Emergent platform.\n\nPRIVACY\n\nThe information sent through the contact form (name, email address, message) is used solely to answer your request. It is visible exclusively by the firm and is never sold, transferred or shared with third parties.\n\nIn accordance with applicable data protection regulations, you have the right to access, rectify and delete your personal information. To exercise this right, write to us at polynesiegestionetprojet@gmail.com.\n\nINTELLECTUAL PROPERTY\n\nAll content on this site (texts, images, logo) is the property of POLYNÉSIE GESTION ET PROJET, unless otherwise stated. Any reproduction, in whole or in part, without prior authorization is prohibited.",
  },
};
